<button
  type="button"
  class="btn btn-primary col-sm-12"
  *ngIf="hasCreatePermission()"
  (click)="onSelectMerchant()"
  data-id="createNewMerchant"
  appPreventDoubleClick
>
  <em class="icon-plus"></em>
  Create New Store
</button>

<div
  class="modal fade"
  bsModal
  #modalCreateNewStore="bs-modal"
  [config]="{ backdrop: 'static' }"
  [formGroup]="merchantForm"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title pull-left">Select Merchant</h6>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideModalCreateNewStore()">
          <em class="icon-close"></em>
        </button>
      </div>
      <div class="modal-body admin-form">
        <div class="container-fluid">
          <div class="form-group">
            <label>Search by: Merchant Name, Tax ID/ID Card, Store Type<span class="text-danger">*</span></label>
            <ng-select
              #selectMerchant
              [items]="merchantList | async"
              placeholder="Please select..."
              notFoundText="No Data"
              formControlName="merchant"
              bindLabel="merchantNameDisplay"
              bindValue="merchant"
              dropdownPosition="auto"
              labelForId="album"
              [loading]="merchantSearchLoading"
              [typeahead]="merchantSearchInput$"
            >
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div>
                  <strong>Merchant Name:</strong>
                  <span [ngOptionHighlight]="search" class="ml-1">
                    {{ item.merchantName }}
                  </span>
                </div>
                <small>
                  <strong>Tax ID/ID Card:</strong
                  ><span [ngOptionHighlight]="search" class="ml-1">{{ item.taxId }}</span
                  >{{ ' | ' }} <strong>Store Type:</strong
                  ><span [ngOptionHighlight]="search" class="ml-1">{{
                    'STORE_TYPE.' + item.merchantType | translate
                  }}</span>
                </small>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!merchantForm.controls.merchant.value || merchantForm.controls.merchant.value.length === 0"
          (click)="goToCreate()"
          appPreventDoubleClick
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
